import script from "./AppMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=0f980944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f980944"]])

export default __exports__